<template>
  <div class="mall-toolbar-box">
    <a
      :href="`https://edu.csdn.net/me/${username}`"
      target="_blank"
      class="my-order"
      @click="go2MyAchievement"
    >
      成就
    </a>
    <a
      v-for="v in extra"
      :key="v.title"
      :href="v.url"
      target="_blank"
      class="my-order"
    >
      {{v.title}}
    </a>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  props: {
    extra: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      username: ''
    };
  },
  computed: {},
  mounted() {
    this.username = Cookies.get('UserName') || '';
  },
  methods: {
    go2MyAchievement(event) {
      if(!this.username) {
        event.preventDefault();
        window.csdn.loginBox.show();
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .toolbar-logo {
  display: none !important;
}
.mall-toolbar-box {
  font-size: 0;

  .my-order {
    display: inline-block;
    color: #222226;
    margin-right: 16px !important;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
<style lang="less">
.custom_toolbar_content_active {
  color: #222226;
  vertical-align: top;
  display: inline-flex;
  align-items: center;
  border-top: 2px solid #fc5531;
  border-bottom: 2px solid #ffffff;
  padding-left: 10px !important;
  padding-right: 10px !important;
  height: 44px;
  box-sizing: content-box !important;
  &:hover {
    color: #222226;
    background: #f0f0f5ed;
    border-bottom: 2px solid #f0f0f5ed;
  }
}
.custom_toolbar_content_nomoral {
  color: #222226;
  display: inline-block;
  text-align: center;
  margin-right: 20px;
  margin: 0px 10px 0px 10px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  vertical-align: top;
  &:hover {
    color: #222226;
    background: #f0f0f5ed;
  }
}
#csdn-toolbar a,   #csdn_tool_otherPlace a {
    font-size: 14px;
}
</style>
